<template>
    <div class="link-node-warp">
        <h4>프로토콜 기본정보</h4>
        <div class="link-item">
            <div class="one">
                <button class="MATERIAL" 
                    @dblclick="tagPopOn('MATERIAL')"
                    :class="nodeLinkData['MATERIAL'].active === false ? 'disabled' : ''"
                    :data-items="nodeLinkData['MATERIAL'].text"
                ><span>재료</span><b>{{ nodeLinkData['MATERIAL'].text }}</b></button>
            </div>
            <div class="two b-r"></div>
            <div class="two"></div>
            <div class="three"></div>
            <div class="three b-t b-r b-l"></div>
            <div class="three"></div>
            <div class="two">
                <button class="MEASUREMENT"
                    @dblclick="tagPopOn('MEASUREMENT')"
                    :class="nodeLinkData['MEASUREMENT'].active === false ? 'disabled' : ''"
                    :data-items="nodeLinkData['MEASUREMENT'].text"
                ><span>측정</span><b>{{ nodeLinkData['MEASUREMENT'].text }}</b></button>
            </div>
            <div class="two">
                <button class="ANALYSIS" 
                    @dblclick="tagPopOn('ANALYSIS')"
                    :class="nodeLinkData['ANALYSIS'].active === false ? 'disabled' : ''"
                    :data-items="nodeLinkData['ANALYSIS'].text"
                ><span>분석</span><b>{{ nodeLinkData['ANALYSIS'].text }}</b></button>
            </div>
            <div class="three"></div>
            <div class="three b-b b-r b-l"></div>
            <div class="three"></div>
            <div class="two b-r"></div>
            <div class="two"></div>
            <div class="one">
                <button class="EQUIPMENT" 
                    @dblclick="tagPopOn('EQUIPMENT')"                
                    :class="nodeLinkData['EQUIPMENT'].active === false ? 'disabled' : ''"
                    :data-items="nodeLinkData['EQUIPMENT'].text"
                ><span>장비</span><b>{{ nodeLinkData['EQUIPMENT'].text }}</b></button>
            </div>
        </div>
        <TagOptionPopTagList />
        <Loading :visible="loading" type="fixed"/>
    </div>
</template>

<script>
  import mixin from "@/mixins/process";
  import CommNew from "@processEditor/CommNew";
  import {checkProtocolLink} from '@mixins/makeLinkInfo.js';
  import TagOptionPopTagList from '@components/TagAddPop/TagOptionPopTagList' ; 
  import { TagAddPopCommMapMutations } from "@TagAddPop/TagAddPopComm"; 
  import Loading from "@/components/common/loading.vue";
  
  import { createNamespacedHelpers } from 'vuex';
  const Dictionary = createNamespacedHelpers('Dictionary');

  export default {
    mixins:[mixin, CommNew],
    props : {
        processInfoSetOn : Boolean,
        treeLoading: {
          type: Boolean,
          default(){
              return false;
          },  
        },
        // protocolId : Number
    } , 
    components : {
        TagOptionPopTagList
        ,Loading
    } , 
    data () {
      return {
        nodeLinkData : {
                EQUIPMENT : {label:'장비',text:'장비',key:null,category:'EQUIPMENT',active:false},
                MATERIAL : {label:'재료',text:'재료',key:null,category:'MATERIAL',active:false},
                MEASUREMENT : {label:'측정',text:'측정목적',key:null,category:'MEASUREMENT',active:false},
                ANALYSIS : {label:'분석',text:'분석목적',key:null,category:'ANALYSIS',active:false},
            },
        disabledNames : ["장비","측정목적","분석목적","재료","장비명"],
        nodeLinkValidData : { "EQUIPMENT" : false, "PURPOSE" : false, "MATERIAL" : false },
        loading: false,
      }
    } , 
    async mounted () {
        // let { nodes, links, protocols } = this.PROCESS_INFO ; 
        this.initData();
        this.initFunc();
        this.setResetLinkNodeFunc(this.initFunc);
    } , 
    watch : {
        processInfoSetOn : function(on){
            if( on === true ) this.initFunc();
        },
        '$route.query.protocolId' : function(protocolId){
            if( protocolId ) this.initFunc();
        },
        loading(value){
            this.$emit("update:treeLoading",value);
        },
    } , 
    methods : {
        ...TagAddPopCommMapMutations([
            'setTagOptionPopAddListViewBln' , 
            'setCrntTagType' , 
            'setCallbackFunc' , 
        ]) ,      
        ...Dictionary.mapMutations(
                [
                        "setResetLinkNodeFunc",
                ]
        ),
        async tagChangeHandler( tagInfo ){
            let { name, tagType, id } = tagInfo;
            let active = !this.disabledNames.includes(name);
            this.nodeLinkData[tagType].text = name;
            this.nodeLinkData[tagType].active = active;
            if( tagType === 'MEASUREMENT' && active && this.nodeLinkData['ANALYSIS'].active === true ){
                this.nodeLinkData['ANALYSIS'].active = false;
                this.nodeLinkData['ANALYSIS'].text = '분석목적';
            }
            if( tagType === 'ANALYSIS' && active && this.nodeLinkData['MEASUREMENT'].active === true ){
                this.nodeLinkData['MEASUREMENT'].active = false;
                this.nodeLinkData['MEASUREMENT'].text = '측정목적';
            }

            if( tagType === 'MEASUREMENT' || tagType === 'ANALYSIS' ){
                this.nodeLinkValidData['PURPOSE'] = active;
            }else{
                this.nodeLinkValidData[tagType] = active;
            }

            this.nodeLinkValid();

            let { key, label } = this.nodeLinkData[tagType];
            let { links, nodes, protocols } = this.PROCESS_INFO;
            let { protocolId } = this.$route.query;
            
            let selectNode = nodes.find(o=>o.key===key)
            selectNode.tagId = id;
            selectNode.text = name;
            selectNode.label = label;
            selectNode.category = tagType;
            const nodeData = {
                json: {
                    nodes, 
                    links
                },
            }

            try {
                const response = await this.$wApi.process.put( {...nodeData}, this.$route.query.processId);
                const crntProtocol = protocols.filter(o=>o.id == protocolId)[0];
                // console.log( "crntProtocol", crntProtocol )
                let putData = {
                    "protocolId": crntProtocol.id,
                }
                let nodeInfo = checkProtocolLink(links, nodes, this.$route.query.keyOfProtocol);
                nodeInfo = nodeInfo.nodeInfo;
                for(let item of Object.entries(nodeInfo)) {
                    // putData[item[0].toLowerCase()] = (Object.keys(item[1])).join(';');
                    putData[item[0].toLowerCase()] = Object.keys(item[1])[0];
                }
                if( putData.analysis ){
                    putData.measurement = " ";
                }else if( putData.measurement ){
                    putData.analysis = " ";
                }
                
                // protocol content update시 장비의 경우 tagId와 넣어줌.
                if(tagType == "EQUIPMENT"){
                    putData.idEquipment = id;
                }
                
                await this.$wApi.protocol.put(putData);

                await this.status.issueListStatus.reload();
            } catch (error) {
                console.log(error)
            }                   
        },
        async tagPopOn(category){
            
            this.loading = true;
            
            // 1. 연결된 공정도 확인
            let connected = await this.$wApi.protocol.connectProtocoList({protocolId : this.$route.query.protocolId}); // 연결된 공정도 확인
            if (connected?.error || connected == null) {
                return;
            }
            if(connected.length > 0){ // 연결된 공정도 확인.
                this.loading = false;
                window.alert("<b>공정도에 연결된 프로토콜의 경우<br/>연결된 재료,목적,장비를 수정할 수 없습니다.</b> ");
                return;
                
            }
            
            // 2. 수정 권한 확인
            const { protocols } = this.PROCESS_INFO ;
            if(!protocols){ // protocols이 세팅 완료되지 않아 null일 경우 return.
                this.loading = false;
                return;
            }
            const crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];
            if(crntProtocol && crntProtocol.editerMode == false){ 
                this.loading = false;
                window.alert("<b>프로토콜을 수정할 권한이 없습니다.</b> ");
                return;
            }
            let changeTagFunc = null;
            // 3. protocol_content 데이터 update
            let {label} = this.nodeLinkData[category]
            changeTagFunc = this.tagChangeHandler;
            this.setCrntTagType({
                tag: {
                    name: label,
                    type: category,
                }
            });
            
            //4. 공개 데이터 확인
            let response = await this.$wApi.protocol.release.get({protocolId: this.$route.query.protocolId}); // 공개 범위 확인
            if (response?.error || response == null) {
                this.loading = false;
                return;
            }
            const publicActive = response.publicActive ? response.publicActive : 0;
            //4-1. 공개된 데이터의 경우 공개 데이터 update. (즉시 적용)
            if (publicActive != 0) {
                const tempTagChangeHandler = this.tagChangeHandler;
                const tempUpdateReleaseData = this.updateReleaseData;
                let updateRelease = async function(tagInfo){
                    await tempTagChangeHandler(tagInfo);
                    await tempUpdateReleaseData();
                }
                changeTagFunc = updateRelease;
            }else{
                changeTagFunc = this.tagChangeHandler;
            }
            
            let requestObj = {
                category : category
                , changeTagFunc : changeTagFunc
                , key : this.nodeLinkData[category].key
                , processId : crntProtocol.onlyProtocolProcessId,
            }
            this.$emit("openDictionaryPopup", requestObj);
            this.loading = false;
        },
        async updateReleaseData() {
            let updateResponse = await this.$wApi.protocol.release.update({protocolId: this.$route.query.protocolId});
            if (updateResponse?.error || updateResponse == null) {
                this.loading = false;
                return;
            }
        },
        initData(){
            this.nodeLinkData = {
                EQUIPMENT : {label:'장비',text:'장비',key:null,category:'EQUIPMENT',active:false},
                MATERIAL : {label:'재료',text:'재료',key:null,category:'MATERIAL',active:false},
                MEASUREMENT : {label:'측정',text:'측정목적',key:null,category:'MEASUREMENT',active:false},
                ANALYSIS : {label:'분석',text:'분석목적',key:null,category:'ANALYSIS',active:false},
            };
        },
        nodeLinkValid(){
            if( Object.values(this.nodeLinkValidData).includes(false) ){
                this.$emit('change', false )
            }else{
                this.$emit('change', true )
            }
        },
        initFunc(){
            this.initData();
            let { protocolId, keyOfProtocol } = this.$route.query ; 
            let { links, nodes } = this.PROCESS_INFO;
            if( !protocolId ) return;
            // console.log( "this.PROCESS_INFO", this.PROCESS_INFO )

            if(!keyOfProtocol) {
                keyOfProtocol = this.PROCESS_INFO.protocols[0].keyOfProtocol;
            }
            
            const linkData = checkProtocolLink(links,nodes,keyOfProtocol);
            for( let node of linkData.nodes ){
                let active = !this.disabledNames.includes(node.text);
                let { text, key, category, label } = node;
                this.nodeLinkData[category] = { text, key, category, label, active };
                if( category === 'MEASUREMENT' || category === 'ANALYSIS' ){
                    this.nodeLinkData['MEASUREMENT'].key = key;
                    this.nodeLinkData['ANALYSIS'].key = key;
                    this.nodeLinkValidData['PURPOSE'] = active;
                }else{
                    this.nodeLinkValidData[category] = active;
                }
            }

            this.nodeLinkValid();
            // console.log( "nodeLinkValidData", this.nodeLinkValidData );
        },
    }
  }
</script>

<style lang="scss" scoped>
.link-node-warp{
    position:fixed;
    right:20px;
    top:300px;
    width:250px;
    border:1px solid #ccc;
    padding:20px 20px 40px;
    border-radius:8px;
    background:#fff;
    z-index:11;    
    h4{
        font-size:16px;
        font-weight:bold;
    }
    .link-item{
        display:flex;
        margin-top:30px;
        flex-wrap: wrap;
        >div{
            min-height:20px;
        }
        .one{
            flex:1 1 100%;
            text-align:center;
        }
        .two{
            flex:1 1 50%;
            text-align:center;
        }
        .three{
            flex:1 1 33.3333%;
        }
        .b-t{
            border-top:1px solid #999;
        }
        .b-r{
            border-right:1px solid #999;
        }
        .b-l{
            border-left:1px solid #999;
        }
        .b-b{
            border-bottom:1px solid #999;
        }
        button{
            position:relative;
            width:80px;
            height:34px;
            padding:8px;
            border-radius:4px;
            color:#fff;
            font-size:13px;
            background: $color-equipment;
            border: 1px solid $color-border-equipment;
            &:after {
                visibility: hidden;
                content: attr(data-items);
                display: block;
                position: absolute; top:105%; right: 0;
                max-width: 220px;
                padding: 8px;
                border-radius: 3px;
                color: #000000;
                font-size: 12px;
                white-space: nowrap;
                background: $color-equipment;
                border: 1px solid $color-border-equipment;
                z-index: 5;
            }
            &:hover {
                &::after {
                    visibility: visible;
                }
            }            
            b{
                display:block;
                color: black;
                text-align:center;
                overflow:hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            span{
                position:absolute;
                display:flex;
                align-items: center;
                justify-content: center;
                top:-12px;
                left:-20px;
                height:24px;width:40px;
                padding:4px 6px;
                border-radius:40px;
                background: $color-equipment;
                border:1px solid $color-border-equipment;
                color: black;
            }
            &.MATERIAL{ 
                background:$color-material;
                border: 1px solid $color-border-material;
                span{ 
                        border:1px solid $color-border-material;
                        color: black;
                }
                &:after{
                    border: 1px solid $color-border-material;
                    background: $color-material;
                    color: black;
                }
            }
            &.MEASUREMENT{ 
                background:$color-measurement;
                border: 1px solid $color-border-measurement;
                span{ 
                        border:1px solid $color-border-measurement;
                        color: black;
                }
                &:after{
                    border: 1px solid $color-border-measurement;
                    background: $color-measurement;
                    color: black;
                }
            }
            &.ANALYSIS{
                background:$color-analysis;
                border: 1px solid $color-border-analysis;
                span{ 
                        border:1px solid $color-border-analysis;
                        color: black;
                        left:auto; 
                        right:-15px;
                }
                &:after{
                    border: 1px solid $color-border-analysis;
                    background: $color-analysis;
                    color: black;
                }
            }

            &.disabled{
                background:#999;
                &:hover {
                    &::after {
                        visibility: hidden;
                    }
                }                 
                // span{ border:1px solid #999;color:#999;}
            }
        }
    }
}
</style>